var React = require('react');

function IconFeedbackSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M512.8 116.2c-229.1 0-413.3 146.4-413.3 346.2 0 122.3 68.9 213.6 172.2 279 10.3 6.9 17.2 17.2 17.2 29.3v120.6c0 10.3 8.6 17.2 17.2 17.2 3.4 0 8.6-1.7 12.1-5.2l94.7-89.6c6.9-6.9 15.5-8.6 24.1-8.6h5.2c22.4 3.4 46.5 5.2 70.6 5.2 229.1 0 413.3-146.4 413.3-346.2.1-201.5-184.2-347.9-413.3-347.9zM340.6 514c-18.9 0-34.4-15.5-34.4-34.4s15.5-34.4 34.4-34.4 34.4 15.5 34.4 34.4-15.4 34.4-34.4 34.4zm172.2 0c-18.9 0-34.4-15.5-34.4-34.4s15.5-34.4 34.4-34.4 34.4 15.5 34.4 34.4-15.4 34.4-34.4 34.4zm172.3 0c-18.9 0-34.4-15.5-34.4-34.4s15.5-34.4 34.4-34.4 34.4 15.5 34.4 34.4S704 514 685.1 514z"}));
}

IconFeedbackSolid.displayName = "IconFeedbackSolid";

IconFeedbackSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFeedbackSolid;

IconFeedbackSolid.default = IconFeedbackSolid;
